import type { SxStyle } from '@aibees/shared/theme';

export const dialogContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => `${p.spacing(2)} !important`,
};
